import vueQr from './vue-qr.vue';

vueQr.install = Vue => Vue.component(vueQr.name, vueQr);

export default vueQr;
